import React, { Component } from 'react';
import { Link } from "react-router-dom";

class NotFound extends Component {
    state = {}
    render() {
        return (
            <div className="not-found-wrapper">
                <div className="circles-layer">
                    <div className="circle -white"></div>
                    <div className="circle -red"></div>
                    <div className="circle -white"></div>
                    <div className="circle -red"></div>
                </div>
                <div className="numbers-layer">
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number">4</div>
                    <div className="number -with-shadow">0</div>
                    <div className="number -with-shadow">0</div>
                    <div className="number -with-shadow">0</div>
                    <div className="number -with-shadow">0</div>
                </div>
                <div className="oops-message">
                    <div className="test">متاسفانه صفحه مورد نظر شما یافت نشد!</div><Link className="button" to="/">رفتن به صفحه نخست</Link>
                </div>
            </div>

        );
    }
}

export default NotFound;   